import { inputLimits } from '@/constants/inputLimits'
import { hasNumbers, hasSpecialCharacters, hasUpperAndLowerCase } from '@/utils'

// Password criteria validation functions

export const passwordCriteriaList = [
  {
    criteria: 'minimumPasswordLength',
    validate: (password: string) => password.length >= inputLimits.password.min,
  },
  {
    criteria: 'lowerAndUpper',
    validate: (password: string) => hasUpperAndLowerCase(password),
  },
  {
    criteria: 'numbers',
    validate: (password: string) => hasNumbers(password),
  },
  {
    criteria: 'specialChar',
    validate: (password: string) => hasSpecialCharacters(password),
  },
]
